var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 19v-6m-2.7 3H19m-9-3H6.4c-1.677 0-2.516 0-3.178.305-.882.405-1.583 1.184-1.948 2.164C1 16.204 1 17.136 1 19M13.15 1.29c1.32.594 2.25 2.031 2.25 3.71 0 1.679-.93 3.116-2.25 3.71M11.35 5c0 2.21-1.612 4-3.6 4s-3.6-1.79-3.6-4 1.612-4 3.6-4 3.6 1.79 3.6 4z",
    stroke: "#252525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersDark);
export default __webpack_public_path__ + "static/media/users-dark.a5a9f3325c74294ff43a76d2594aa27f.svg";
export { ForwardRef as ReactComponent };